<ng-container *ngIf="type === skeletonOptions.POST_COVER">
	<div role="status" class="w-full animate-pulse">
		<div class="w-full aspect-7/10 bg-gray-200 rounded-md dark:bg-gray-700 mb-4"></div>
		<span class="sr-only">Loading...</span>
	</div>
</ng-container>

<ng-container *ngIf="type === skeletonOptions.POST_COVER_LIST">
	<div class="w-full grid grid-cols-3 gap-2 mt-5">
		<ng-container *ngFor="let i of numSequence(total)">
			<div role="status" class="w-full animate-pulse px-2">
				<div class="w-full aspect-7/10 bg-gray-100 rounded-lg dark:bg-gray-700 mb-1"></div>
			</div>
		</ng-container>
	</div>
</ng-container>

<ng-container *ngIf="type === skeletonOptions.POST_LIST">
	<div class="w-full grid grid-cols-3 gap-2 mt-5">
		<ng-container *ngFor="let i of numSequence(total)">
			<div role="status" class="w-full animate-pulse px-2">
				<div class="w-full aspect-7/10 bg-gray-100 rounded-lg dark:bg-gray-700 mb-1"></div>
				<div class="flex items-center w-full space-x-2 mb-2 mt-2.5 px-2">
					<div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-8/12"></div>
				</div>
				<div class="flex items-center w-full space-x-2 mb-4 px-2">
					<div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
				</div>
				<span class="sr-only">Loading...</span>
			</div>
		</ng-container>
	</div>
</ng-container>

<ng-container *ngIf="type === skeletonOptions.EVENT">
	<ng-container *ngFor="let i of numSequence(total)">
		<div
			class="w-full border border-gray-200 rounded-2xl shadow animate-pulse dark:border-gray-700 mb-5">
			<div
				class="flex items-center rounded-t-2xl justify-center aspect-[3/1] mb-4 bg-gray-300 dark:bg-gray-700">
				<svg
					class="w-12 h-12 text-gray-200 dark:text-gray-600"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true"
					fill="currentColor"
					viewBox="0 0 640 512">
					<path
						d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
				</svg>
			</div>
			<div class="px-5">
				<div class="flex items-center w-full space-x-2 mb-2.5">
					<div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-44"></div>
					<div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
					<div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16"></div>
				</div>
				<div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
				<div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
				<div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10/12"></div>
			</div>
			<div class="flex items-center mt-4 space-x-3 px-5 mb-5">
				<svg
					class="text-gray-200 w-10 h-10 dark:text-gray-700"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="currentColor">
					<path
						fill-rule="evenodd"
						d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5zm6.61 10.936a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
						clip-rule="evenodd" />
					<path
						d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
				</svg>

				<div>
					<div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>
					<div class="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
				</div>
			</div>
			<span class="sr-only">Loading...</span>
		</div>
	</ng-container>
</ng-container>

<ng-container *ngIf="type === skeletonOptions.COMMENT">
	<ng-container *ngFor="let item of numSequence(total)">
		<div class="py-3 px-4 animate-pulse">
			<div class="flex flex-row items-start space-x-4">
				<div class="flex-shrink-0">
					<div class="w-8 h-8 rounded-full bg-slate-200"></div>
				</div>
				<div class="w-full flex flex-1 flex-col">
					<div class="w-2/6 h-4 rounded-md bg-slate-200 mt-1.5"></div>
					<div class="w-full h-4 rounded-md bg-slate-200 mt-2"></div>
					<div class="w-full h-4 rounded-md bg-slate-200 mt-1"></div>
					<div class="w-4/6 h-4 rounded-md bg-slate-200 mt-1"></div>
					<div class="w-full flex mt-2 space-x-3">
						<div class="w-2/6 h-6 rounded-md bg-slate-200 mt-1"></div>
						<div class="w-2/6 h-6 rounded-md bg-slate-200 mt-1"></div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-container>

<ng-container *ngIf="type === skeletonOptions.HORIZONTAL_POST_LIST">
	<div class="grid grid-cols-2 gap-4 px-4 py-5">
		<ng-container *ngFor="let item of numSequence(total)">
			<div class="flex animate-pulse">
				<div class="w-2/6">
					<div class="w-full aspect-7/10 bg-slate-200 rounded"></div>
				</div>
				<div class="w-4/6 pl-2">
					<div class="w-4/6 h-3 rounded-md bg-slate-200 mt-1.5"></div>
					<div class="w-full h-3.5 rounded-md bg-slate-200 mt-1.5"></div>
					<div class="w-full h-3.5 rounded-md bg-slate-200 mt-1"></div>
				</div>
			</div>
		</ng-container>
	</div>
</ng-container>
